import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'login',
    name: 'Login',
    meta: { title: '登录', public: true, hiddenHeader: true, fullPage: true },
    component: () => import('@/views/auth/Login.vue')
  },
  {
    path: 'register',
    name: 'Register',
    meta: { title: '注册', public: true, hiddenHeader: true, fullPage: true },
    component: () => import('@/views/auth/Register.vue')
  },
  {
    path: 'mock-login',
    name: 'MockLogin',
    meta: { title: '拟登录', public: true, hiddenHeader: true, fullPage: true },
    component: () => import('@/views/auth/MockLogin.vue')
  },
  {
    path: 'register-invite',
    name: 'RegisterInvite',
    meta: {
      title: '邀请注册',
      public: true,
      hiddenHeader: true,
      fullPage: true
    },
    component: () => import('@/components/global/auth/RegisterInvite.vue')
  },
  // 重置密码
  {
    path: 'reset-pass',
    name: 'ResetPass',
    meta: {
      title: '重置密码',
      public: true,
      hiddenHeader: true,
      fullPage: true
    },
    component: () => import('@/views/auth/ResetPass.vue')
  },
  // 找回密码
  {
    path: 'retrieve-pass',
    name: 'RetrievePass',
    meta: {
      title: '找回密码',
      public: true,
      hiddenHeader: true,
      fullPage: true
    },
    component: () => import('@/views/auth/RetrievePass.vue')
  }
]

export default routes
